import { render, staticRenderFns } from "./OpenTablet.vue?vue&type=template&id=445a48d3"
import script from "./OpenTablet.vue?vue&type=script&lang=js"
export * from "./OpenTablet.vue?vue&type=script&lang=js"
import style0 from "./OpenTablet.vue?vue&type=style&index=0&id=445a48d3&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports